import { Dispatch, ReactNode, SetStateAction } from 'react';
import styled from '@emotion/styled';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material';
import { Drawer } from 'src/components/atoms';

interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  children: ReactNode;
  isMobileDrawer: boolean;
}

const StyledOpenDrawerButton = styled(IconButton)`
  position: fixed;
  top: 0.75rem;
  left: 0.75rem;
  z-index: 500;
`;

const StyledMobileOpenDrawerButton = styled(IconButton)`
  top: 0.25rem;
  left: 0.75rem;
`;

export const DrawerSideBar = ({ isOpen, isMobileDrawer, setIsOpen, children }: Props) => {
  const closeDrawer = (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setIsOpen(false);
  };

  return (
    <>
      <Drawer
        sx={{ width: '21rem' }}
        PaperProps={{ sx: { width: '21rem' } }}
        anchor='left'
        open={isOpen}
        onClose={closeDrawer}
        ModalProps={{ onBackdropClick: closeDrawer }}
      >
        {children}
      </Drawer>
      <OpenDrawerButton setIsOpen={setIsOpen} isMobileDrawer={isMobileDrawer} />
    </>
  );
};

interface OpenDrawerButtonProps {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isMobileDrawer?: boolean;
}

const OpenDrawerButton = ({ setIsOpen, isMobileDrawer }: OpenDrawerButtonProps) => {
  const toggleDrawer = () => setIsOpen(prevState => !prevState);

  if (isMobileDrawer) {
    return (
      <StyledMobileOpenDrawerButton onClick={toggleDrawer}>
        <MenuIcon />
      </StyledMobileOpenDrawerButton>
    );
  }

  return (
    <StyledOpenDrawerButton onClick={toggleDrawer}>
      <MenuIcon />
    </StyledOpenDrawerButton>
  );
};
